import styled from 'styled-components';

export const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	padding: 8px 16px;
	box-sizing: border-box;
`;
